import React, { useState, useEffect, useRef } from "react";  // <-- added useRef
import {
  TriangleAlert,
  MessageSquare,
  Bell,
  TrendingUp,
  TrendingDown,
  ChevronLeft,
  Search,
} from "lucide-react";
import MISnavbar from "../Navbar/MISnavbar";
import DisbursalTracking from "./Disbursal Tracking/Disbursaltracking";
import FunnelVisualization from "../Funnel Visualization/Funnelvisualization";
import { dummyData, getDataForMonth } from "../Dummydata/dummydata";
import Financial from "../Financial Summary/Financial";
import EmiBehavour from "../Emi-behaviour/EmiBehavour";
import ProjectVSActual from "../project vs actul/ProjectVSActual";
import ActualVsProfitContainer from "../Actual-vs-profit/ActualVsProfitContainer";
import { getOverdueSummary } from "../API's/Actioncreator";
import "../style/mis.scss";
import CommonPanel from "../common/CommonPannel";
import CustomDateScroll from "../common/CustomDateScroll";
import Loader from '../../../../presentationals/Loader/Loader.component'
import StyledTooltip from '../common/StyledTooltip'
import DateFilterSelect from '../../../../CustomDatePicker/DateFilterSelectold'
import moment from "moment";
import { APIS } from "../../../../../utils/api-factory";


const getCurrentMonth = () => {
  const date = new Date();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
};

const getCurrentMonthRange = (type) => {
  const now = moment();
  const start = now.clone().startOf("month");
  const end = now.clone().endOf("month");
  if (type === "fromDate") return start.format("YYYY-MM-DD");
  if (type === "toDate") return end.format("YYYY-MM-DD");
  return "";
};

// ── Skeleton card shown while data is loading ──────────────────────────────
const SkeletonCard = ({ bg }) => (
  <div style={{
    backgroundColor: bg,
    borderRadius: "10px",
    padding: "20px 24px",
    animation: "skeletonPulse 1.4s ease-in-out infinite",
  }}>
    <div style={{
      height: "13px", width: "50%", borderRadius: "6px",
      backgroundColor: "rgba(0,0,0,0.08)", marginBottom: "14px",
    }} />
    <div style={{
      height: "26px", width: "65%", borderRadius: "6px",
      backgroundColor: "rgba(0,0,0,0.10)",
    }} />
    <style>{`
      @keyframes skeletonPulse {
        0%,100% { opacity: 1; }
        50%      { opacity: 0.45; }
      }
    `}</style>
  </div>
);

const SKELETON_CARDS = [
  { bg: "#EFF6FF" },
  { bg: "#f0fdf4" },
  { bg: "#fefce8" },
];

// ───────────────────────────────────────────────────────────────────────────

export default function FinancialMis({ admin, pageViewHandler }) {
  const [refreshKey, setRefreshKey] = useState(0);
  const [isManualRefresh, setIsManualRefresh] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState([getCurrentMonth()]);
  const [loader, setLoader] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);       // <-- new
  const [selectedView, setSelectedView] = useState("disbursal");
  const [tags, setTags] = useState({ 0: [], 1: [] });
  const [tagInputs, setTagInputs] = useState({ 0: "", 1: "" });
  const [activePanel, setActivePanel] = useState(null);
  const [comments, setComments] = useState([]);
  const [reminders, setReminders] = useState([]);
  const [alertsNotes, setAlertsNotes] = useState([]);
  const [overdueSummaryData, setOverdueSummaryData] = useState(null);
  const [commonFilter, setcommonFilter] = useState({
    fromDate: getCurrentMonthRange("fromDate"),
    toDate: getCurrentMonthRange("toDate"),
    nbfc: "",
  });
  const [appliedFilter, setAppliedFilter] = useState({
    fromDate: getCurrentMonthRange("fromDate"),
    toDate: getCurrentMonthRange("toDate"),
    nbfc: "",
  });
  const [appliedMonths, setAppliedMonths] = useState([getCurrentMonth()]);
  const [SelectedMonthsFromDate, setSelectedMonthstoDate] = useState({
    fromDate: getCurrentMonthRange("fromDate"),
    toDate: getCurrentMonthRange("toDate"),
    nbfc: "",
  });
  const [nbfcData, setnbfcData] = useState([]);

  const abortControllerRef = useRef(null);                             // <-- new

  // ── helper: cancel previous request, wipe stale data, show skeleton ──────
  const cancelAndReset = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    setOverdueSummaryData(null);   // clear old values immediately
    setSkeletonLoading(true);      // show skeleton
  };
  // ─────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    const getNbfcList = () => {
      fetch(APIS.GET_LIST_OF_NBFC)
        .then(res => res.json())
        .then(res => setnbfcData(res));
    };
    getNbfcList();
  }, []);

  // ── fires when selected months change to update input boundaries (UI state only) ──
  useEffect(() => {
    if (selectedMonths.length === 0) return;

    const monthMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3,
      May: 4, Jun: 5, Jul: 6, Aug: 7,
      Sep: 8, Oct: 9, Nov: 10, Dec: 11,
    };

    const sortedMonths = [...selectedMonths].sort((a, b) => {
      const [mA, yA] = a.split(" ");
      const [mB, yB] = b.split(" ");
      return new Date(yA, monthMap[mA]) - new Date(yB, monthMap[mB]);
    });

    const [startMonthName, startYear] = sortedMonths[0].split(" ");
    const startMonthIndex = monthMap[startMonthName];

    const [endMonthName, endYear] = sortedMonths[sortedMonths.length - 1].split(" ");
    const endMonthIndex = monthMap[endMonthName];

    const startDate = `01-${String(startMonthIndex + 1).padStart(2, "0")}-${startYear}`;
    const lastDay = new Date(endYear, endMonthIndex + 1, 0).getDate();
    const endDate = `${lastDay}-${String(endMonthIndex + 1).padStart(2, "0")}-${endYear}`;

    const fromDate = moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    const toDate = moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD");

    setcommonFilter(prev => ({ ...prev, fromDate, toDate }));
    setSelectedMonthstoDate({ fromDate, toDate, nbfc: "" });
  }, [selectedMonths]);

  // ── Unified Effect: fires when appliedMonths or appliedFilter (dates/nbfc) changes ──
  useEffect(() => {
    if (appliedMonths.length === 0) return;

    cancelAndReset();
    const signal = abortControllerRef.current.signal;

    const startDate = moment(appliedFilter.fromDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    const endDate = moment(appliedFilter.toDate, "YYYY-MM-DD").format("DD-MM-YYYY");

    setLoader(true);

    new Promise((resolve, reject) => {
      getOverdueSummary(startDate, endDate, appliedFilter.nbfc ?? "", resolve, reject, signal);
    })
      .then((response) => {
        if (signal.aborted) return;
        if (response?.status == 200 && response?.message == "success") {
          setOverdueSummaryData(response);
        } else {
          setOverdueSummaryData(null);
        }
      })
      .catch((e) => {
        if (signal.aborted) return;
        setOverdueSummaryData(null);
        console.error("Failed to fetch overdue summary:", e);
      })
      .finally(() => {
        if (!signal.aborted) {
          setLoader(false);
          setSkeletonLoading(false);
        }
      });

    return () => { abortControllerRef.current?.abort(); };
  }, [appliedMonths, appliedFilter.fromDate, appliedFilter.toDate, appliedFilter.nbfc]);

  // ─────────────────────────────────────────────────────────────────────────

  const currentData = appliedMonths.length > 0
    ? getDataForMonth(appliedMonths[0])
    : getDataForMonth("Apr 2026");

  const mappedAlerts = overdueSummaryData?.data?.alerts?.map((alert) => ({
    title: alert.metricName,
    trend: alert.direction.toLowerCase(),
    percent: `${Math.abs(alert.deviationPct).toFixed(1)}%`,
    description: alert.message,
  })) || [];

  const alertData = mappedAlerts.length > 0 ? mappedAlerts : currentData.alerts || [];

  const summaryCards = overdueSummaryData?.data
    ? [
      { label: "Overdue Amount", value: overdueSummaryData.data.overdueAmountDisplay || "₹0", overallValue: overdueSummaryData.data.overdueAmount || "₹0", color: "#155DFC", bg: "#EFF6FF" },
      { label: "Projected Collection", value: overdueSummaryData.data.projectedCollectionDisplay || "₹0", overallValue: overdueSummaryData.data.projectedCollection || "₹0", color: "#16a34a", bg: "#f0fdf4" },
      { label: "Promise to Pay", value: overdueSummaryData.data.promiseToPayDisplay || "₹0", overallValue: overdueSummaryData.data.promiseToPay || "₹0", color: "#d97706", bg: "#fefce8" },
    ]
    : currentData.financial
      ? [
        { label: "Overdue Amount", value: `₹${currentData.financial.overdueAmount}`, color: "#155DFC", bg: "#EFF6FF" },
        { label: "Projected Collection", value: `₹${currentData.financial.projectedCollection}`, color: "#16a34a", bg: "#f0fdf4" },
        { label: "Promise to Pay", value: `₹${currentData.financial.promiseToPay}`, color: "#d97706", bg: "#fefce8" },
      ]
      : [];

  const handleTagKeyDown = (e, idx) => {
    if (e.key === "Enter" && tagInputs[idx].trim()) {
      setTags(prev => ({ ...prev, [idx]: [...prev[idx], tagInputs[idx].trim()] }));
      setTagInputs(prev => ({ ...prev, [idx]: "" }));
    }
  };


  const handleApiRefetch = () => {
   
   setIsManualRefresh(true);

    // trigger child component APIs again
    setRefreshKey(prev => prev + 1);
  };

  const handleFetchData = () => {
    setAppliedMonths(selectedMonths);
    setAppliedFilter({
      fromDate: commonFilter.fromDate,
      toDate: commonFilter.toDate,
      nbfc: commonFilter.nbfc,
    });
  };

  return (
    <div className="mis-main">
      {loader ? <Loader /> : ""}
      <div style={{ background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 50%, #a855f7 100%)", padding: "28px 32px" }}>
        <h1
          style={{ margin: "0 0 6px", fontSize: "26px", fontWeight: 700, color: "#ffffff", letterSpacing: "-0.3px", display: "inline-flex", gap: "5px", cursor: "pointer" }}
          onClick={(e) => pageViewHandler(e, "landingPage")}
        >
          <ChevronLeft style={{ width: "auto" }} /> Financial MIS Dashboard
        </h1>
        <p style={{ margin: 0, fontSize: "15px", color: "rgba(255,255,255,0.82)", fontWeight: 400 }}>
          Advanced Collection, Disbursal &amp; Financial Analytics
        </p>
      </div>

      <div
        className="container-fluid"
        style={{
          minHeight: "100vh",
          backgroundColor: "#f8fafa",
          fontFamily: "system-ui, -apple-system, sans-serif",
          padding: window.innerWidth > 1800 ? "40px 70px 0 70px" : "",
        }}
      >
        <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", padding: "28px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>

          {/* ── Top bar ── */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}>
            <h1 style={{ margin: 0, fontSize: "clamp(15px, 1.8vw, 18px)", fontWeight: "600", color: "#1e293b" }}>
              Select Month(s)
            </h1>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap", position: "relative" }}>
              <div style={{ position: "relative", border: "1px solid #FEF2F2", padding: "8px 14px", borderRadius: "8px", backgroundColor: "#FEF2F2", color: "#E7000B", display: "flex", alignItems: "center", gap: "6px", fontSize: "clamp(12px, 1.2vw, 14px)", fontWeight: "500", cursor: "pointer" }}>
                <span style={{ position: "absolute", top: "-8px", right: "-8px", backgroundColor: "#E7000B", color: "#fff", borderRadius: "50%", width: "18px", height: "18px", fontSize: "clamp(10px, 0.8vw, 11px)", fontWeight: "700", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {alertData ? alertData.length : 0}
                </span>
                <TriangleAlert size={16} color="#E7000B" />
                <div onClick={() => setActivePanel("alerts")}>Alerts</div>
              </div>
              <div onClick={() => setActivePanel("comments")} style={{ border: "1px solid #EFF6FF", padding: "8px 14px", borderRadius: "8px", backgroundColor: "#EFF6FF", color: "#1e293b", display: "flex", alignItems: "center", gap: "6px", fontSize: "clamp(12px, 1.2vw, 14px)", cursor: "pointer" }}>
                <MessageSquare size={16} color="#155DFC" /> Comments
              </div>
              <div onClick={() => setActivePanel("reminders")} style={{ border: "1px solid #FAF5FF", padding: "8px 14px", borderRadius: "8px", backgroundColor: "#FAF5FF", color: "#1e293b", display: "flex", alignItems: "center", gap: "6px", fontSize: "clamp(12px, 1.2vw, 14px)", cursor: "pointer" }}>
                <Bell size={16} color="#9810FA" /> Reminders
              </div>
            </div>
          </div>

          <CustomDateScroll selectedMonths={selectedMonths} setSelectedMonths={setSelectedMonths} />

          {/* ── Date + NBFC filters ── */}
          {selectedMonths.length > 0 && (
            <div style={{ boxSizing: "border-box", borderRadius: "16px", margin: "30px 0", display: "flex", gap: "10px", justifyContent: 'space-between', alignItems: 'end' }}>
              <div style={{ display: "flex", gap: "10px", alignItems: "end" }}>
                <div>
                  <label style={{ fontSize: "12px", fontWeight: "400" }}>Start Date</label>
                  <input type="date" style={{ borderRadius: "12px", border: "1px solid rgb(226,232,240)", padding: "10px", background: "#fff", display: "block", minWidth: window.innerWidth > 1800 ? "250px" : "200px" }}
                    min={SelectedMonthsFromDate?.fromDate} value={commonFilter?.fromDate}
                    onChange={(e) => setcommonFilter(prev => ({ ...prev, fromDate: e.target.value }))} />
                </div>
                <div><h5 style={{ margin: "0px 0 15px 0" }}>::</h5></div>
                <div>
                  <label style={{ fontSize: "12px", fontWeight: "400" }}>End Date</label>
                  <input type="date" style={{ borderRadius: "12px", border: "1px solid rgb(226,232,240)", padding: "10px", background: "#fff", display: "block", minWidth: window.innerWidth > 1800 ? "250px" : "200px" }}
                    min={SelectedMonthsFromDate?.fromDate} max={SelectedMonthsFromDate?.toDate}
                    value={commonFilter?.toDate}
                    onChange={(e) => setcommonFilter(prev => ({ ...prev, toDate: e.target.value }))} />
                </div>
                <div>
                  <label style={{ fontSize: "12px", fontWeight: "400" }}>NBFC</label>
                  <select style={{ borderRadius: "12px", border: "1px solid rgb(226,232,240)", padding: "10px", background: "#fff", display: "block", minWidth: window.innerWidth > 1800 ? "250px" : "200px" }}
                    value={commonFilter?.nbfc}
                    onChange={(e) => {
                      const newNbfc = e.target.value;
                      setcommonFilter(prev => ({ ...prev, nbfc: newNbfc }));
                    }}>
                    <option value="">Select NBFC</option>
                    {nbfcData?.length > 0 && nbfcData.map((val, id) => (
                      <option key={id} value={val?.nbfcId}>{val?.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
                <button
                  className="btn"
                  style={{
                    background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                    color: "#ffffff",
                    border: "none",
                    padding: '10px 18px',
                    borderRadius: '12px',
                    fontWeight: '600',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.2)',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                  onClick={handleFetchData}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = '0 6px 12px -2px rgba(37, 99, 235, 0.3)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(37, 99, 235, 0.2)';
                  }}
                >
                  <Search size={16} /> Fetch Data
                </button>
                <button className="btn btn-primary" style={{ padding: '10px 13px', minWidth: 'auto', borderRadius: '12px' }} onClick={() => handleApiRefetch()}>
                  <i className="fa fa-refresh"></i> Refresh
                </button>
              </div>
            </div>
          )}

          <CommonPanel open={activePanel === "comments"} onClose={() => setActivePanel(null)} title="Comments & Notes" placeholder="Add a comment..." data={comments} addItem={(c) => setComments([c, ...comments])} theme="blue" />
          <CommonPanel open={activePanel === "reminders"} onClose={() => setActivePanel(null)} title="Reminders & Follow-ups" placeholder="Add a reminder..." data={reminders} addItem={(c) => setReminders([c, ...reminders])} theme="purple" />

          {/* ── Alert cards ── */}
          <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "24px", borderBottom: "1px solid #eee" }}>
            {alertData.map((alert, idx) => (
              <div key={idx} style={{ backgroundColor: "#FEF2F2", border: "1px solid #fee2e2", borderLeft: "5px solid #E7000B", borderRadius: "10px", padding: "16px 20px" }}>
                <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", gap: "6px", marginBottom: "6px", padding: "10px", width: "fit-content" }}>
                  <TriangleAlert size={16} color="#E7000B" />
                  <span style={{ color: "#82181A", fontSize: "clamp(14px,1.6vw,16px)", fontWeight: "500", whiteSpace: "nowrap" }}>{alert.title}</span>
                  {alert.trend === "up" ? <TrendingUp size={13} color="#E7000B" /> : <TrendingDown size={13} color="#00A63E" />}
                  <span style={{ fontSize: "clamp(10px,0.9vw,12px)", color: alert.trend === "up" ? "#E7000B" : "#00A63E", fontWeight: "500", whiteSpace: "nowrap" }}>{alert.percent}</span>
                </div>
                <p style={{ margin: "0 0 10px 22px", fontSize: "clamp(11px,0.9vw,13px)", color: "#E7000B" }}>{alert.description}</p>
                {tags[idx]?.length > 0 && (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "8px", marginLeft: "22px" }}>
                    {tags[idx].map((tag, ti) => (
                      <span key={ti} style={{ backgroundColor: "#fee2e2", color: "#E7000B", borderRadius: "4px", padding: "2px 8px", fontSize: "clamp(10px,0.8vw,12px)" }}>{tag}</span>
                    ))}
                  </div>
                )}
                <input type="text" placeholder="Add tag and press Enter..." value={tagInputs[idx] ?? ""}
                  onChange={(e) => setTagInputs(prev => ({ ...prev, [idx]: e.target.value }))}
                  onKeyDown={(e) => handleTagKeyDown(e, idx)}
                  style={{ marginLeft: "22px", width: "300px", padding: "7px 12px", borderRadius: "6px", border: "1px solid #D1D5DC", backgroundColor: "rgb(254,242,242)", fontSize: "clamp(11px,0.9vw,13px)", color: "#64748b", outline: "none" }} />
              </div>
            ))}
            <p style={{ margin: "0 0 24px 0", fontSize: "clamp(12px,1.2vw,14px)", color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {appliedMonths.length > 0 ? `Viewing: ${appliedMonths.join(", ")}` : "No months selected"}
            </p>
          </div>

          {/* ── Summary cards (skeleton-aware) ── */}
          <h2 style={{ margin: "0 0 16px 0", fontSize: "clamp(14px,1.6vw,16px)", fontWeight: "500", color: "#1e293b" }}>
            Financial Summary for Selected Period
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px" }}>
            {skeletonLoading
              ? SKELETON_CARDS.map((s, i) => <SkeletonCard key={i} bg={s.bg} />)
              : summaryCards.map((card, idx) => (
                <div key={idx} style={{ backgroundColor: card.bg, borderRadius: "10px", padding: "20px 24px" }}>
                  <div style={{ fontSize: "clamp(12px,1.2vw,14px)", color: "#64748b", marginBottom: "8px" }}>{card.label}</div>
                  <StyledTooltip value={card?.overallValue}>
                    <div style={{ fontSize: "clamp(22px,3vw,26px)", fontWeight: "700", color: card?.color }}>{card.value}</div>
                  </StyledTooltip>
                </div>
              ))
            }
          </div>
        </div>

        <div style={{ marginTop: "20px" }}>
          <MISnavbar onSelect={setSelectedView} />
        </div>

        <div style={{ paddingBottom: "20px" }}>
          {appliedMonths.length > 0 ? (
            <>
              {selectedView === "disbursal" && <DisbursalTracking selectedMonth={appliedMonths} commonFilter={appliedFilter}  refreshKey={refreshKey} isManualRefresh={isManualRefresh} setIsManualRefresh={setIsManualRefresh} />}
              {selectedView === "financial" && <Financial selectedMonth={appliedMonths} commonFilter={appliedFilter} refreshKey={refreshKey} isManualRefresh={isManualRefresh} setIsManualRefresh={setIsManualRefresh} />}
              {selectedView === "funnel" && <FunnelVisualization selectedMonth={appliedMonths} commonFilter={appliedFilter} />}
              {selectedView === "emi" && <EmiBehavour selectedMonth={appliedMonths} commonFilter={appliedFilter} />}
              {selectedView === "actualVsProfit" && <ActualVsProfitContainer selectedMonth={appliedMonths} commonFilter={appliedFilter} />}
              {selectedView === "projection" && <ProjectVSActual selectedMonth={appliedMonths} commonFilter={appliedFilter} />}
            </>
          ) : (
            <div style={{ padding: "40px", textAlign: "center", color: "#94a3b8" }}>
              Please select at least one month
            </div>
          )}
        </div>
      </div>
    </div>
  );
}